/**
 * Mehrfachauswahl der EWK-Produktarten (Anlage 1 EWKFondsG) als Chip-Toggles.
 * Nur aktive Kategorien sind wählbar; bereits gewählte inaktive bleiben sichtbar.
 */
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const fmtSatz = (v) => (v == null ? 'Satz fehlt'
  : `${Number(v).toLocaleString('de-DE', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} €/kg`);

export default function EwkKategorienPicker({ kategorien, selected, onChange, error }) {
  const list = kategorien.filter((k) => k.aktiv !== false || selected.includes(k.schluessel));
  const toggle = (s) => onChange(selected.includes(s) ? selected.filter((x) => x !== s) : [...selected, s]);

  if (error) {
    return (
      <p className="text-sm text-red-600 rounded-lg border border-red-200 bg-red-50 px-3 py-2">
        EWK-Kategorien konnten nicht geladen werden ({error.message}). Migration 20260907_03_ewk_gewicht_grundpreis.sql ausführen.
      </p>
    );
  }
  if (list.length === 0) {
    return <p className="text-sm text-slate-400">Keine EWK-Kategorien hinterlegt — unter System → EWK-Kategorien anlegen.</p>;
  }
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="EWK-Produktarten">
      {list.map((k) => {
        const on = selected.includes(k.schluessel);
        return (
          <button
            key={k.schluessel}
            type="button"
            aria-pressed={on}
            onClick={() => toggle(k.schluessel)}
            className={cn(
              'min-h-[44px] rounded-lg border px-3 py-1.5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-950',
              on ? 'border-brand-950 bg-brand-950 text-white' : 'border-slate-200 bg-white text-slate-700 hover:border-slate-400',
              k.aktiv === false && 'opacity-60'
            )}
          >
            <span className="flex items-center gap-1.5 text-sm font-medium">
              {on && <Check className="w-3.5 h-3.5" />}
              {k.name}
            </span>
            <span className={cn('block text-[11px] tabular-nums', on ? 'text-white/70' : 'text-slate-400')}>{fmtSatz(k.abgabesatz_eur_kg)}</span>
          </button>
        );
      })}
    </div>
  );
}
